import { buildSharedRunPathname } from 'Pods/ThreeDStudio/Hooks/buildSharedRunPathname'

import { GENERATION_STATUS } from './constants'

// Builds the finished-run projection consumers render, from a run's serialized
// attributes (the GeneratorRunsChannel broadcast or a /runs/:id response). Shared by
// the /ai studio's run-channel hook and the global nav producer so both emit one shape.
// A run with an output file is a success; anything else (failed/canceled/timed out/
// nsfw) is surfaced as a failure with whatever message the backend provided.
export function buildLastResult(attributes = {}, { pathname } = {}) {
  const {
    id,
    generatorSessionId,
    providerModelId,
    slug,
    title,
    prompt,
    outputAssets,
    failureReason,
    failureMessage,
    providerErrorCode,
    createdAt,
  } = attributes
  const base = {
    runId: id,
    sessionId: generatorSessionId,
    providerModelId,
    finishedAt: createdAt || new Date().toISOString(),
  }

  const fileUrl = outputAssets?.[0]?.fileUrl
  if (!fileUrl) {
    return {
      ...base,
      status: GENERATION_STATUS.FAILED,
      failureReason,
      failureMessage,
      providerErrorCode,
    }
  }

  return {
    ...base,
    status: GENERATION_STATUS.SUCCEEDED,
    slug,
    title: title ?? prompt,
    previewUrl: outputAssets?.[0]?.previewUrl,
    // Successful broadcasts can arrive before assign_slug! runs, so `slug` may be
    // blank while id/title are present. Reuse buildSharedRunPathname's id/title
    // fallback so off-/ai consumers still get a working model URL, not bare /ai.
    pathname: pathname || buildSharedRunPathname({ id, slug, title: title ?? prompt }),
  }
}

export default buildLastResult
